import React, { useState, useEffect, useReducer, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { setFilter } from '../../actions';
import { Grid, Switch, FormControlLabel, Typography } from '@material-ui/core';
import { styles } from './styles';
import SearchByText from './SearchByText';
import SearchByDate from './SearchByDate';
import SearchByStatus from './SearchByStatus';
import { useTranslation } from 'react-i18next';

import { Auth } from 'aws-amplify';

const initialState = {
  text: '',
  date: '',
  status: ''
};

function reducer (state, action) {
  switch (action.type) {
    case 'SEARCH_TEXT':
      return { ...state, ...action.payload };
    case 'SEARCH_DATE':
      return { ...state, ...action.payload };
    case 'SEARCH_STATUS':
      return { ...state, ...action.payload };
    default:
      throw new Error();
  }
}

const parseNameFilter = (pathname) => {
  switch (pathname) {
    case '/identity':
      return 'identity';
    case '/template':
      return 'templates';
    case '/file':
      return 'files';
    case '/document':
      return 'pending';
    case '/document/finished':
      return 'finished';
    case '/bundle':
      return 'bundle';
    default:
      return '';
  }
};

const SearchToolbar = ({ visibleFor = [], setSearchByDocument }) => {
  const { path: pathname } = useRouteMatch();
  const filterName = parseNameFilter(pathname);
  const dispatch = useDispatch();
  const [state, dispatchReduce] = useReducer(reducer, initialState);
  const { t } = useTranslation();
  const [actualOwner, setActualOwner] = useState('');
  const [changeStyles, setChangeStyles] = useState(false);

  let user = '';

  async function getUser () {
    let currentUser;
    try {
      currentUser = await Auth.currentAuthenticatedUser();
      user = currentUser.username;
    } catch (err) {
      console.log(err);
    }
  }
  getUser();

  useEffect(() => {
    dispatch(setFilter(
      { [filterName]: Object.values(state).filter(value => value !== null && value !== ''),
        owner: actualOwner }));
  }, [state, actualOwner]);

  const setFilterByText = (payload) => {
    dispatchReduce({ type: 'SEARCH_TEXT', payload });
  };

  const setFilterByDate = (payload) => {
    dispatchReduce({ type: 'SEARCH_DATE', payload });
  };

  const setFilterByStatus = (payload) => {
    dispatchReduce({ type: 'SEARCH_STATUS', payload });
  };

  const classes = styles();

  if (visibleFor.includes(pathname)) {
    return (
      <Grid container spacing={3} className={classes.marginFiltersContainer}>
        <Grid item xs={12} lg={12}>
          <Grid container
            spacing={3}>
            <Grid item lg={12}>
              <SearchByText changeStyles={changeStyles} action={setFilterByText} />
            </Grid>
            { filterName === 'bundle' &&
            <Grid item lg={12}>
              <Grid style={{
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column'
              }} container>
                <Grid item >
                  <Typography style={{ textAlign: 'center' }} variant='body2' color='textPrimary'>
                    {t('bundleListView:searchByDocument')}
                  </Typography>
                </Grid>
                <Grid >
                  <Switch color='primary' onChange={() => {
                    setSearchByDocument((prevSearchByDocument) => !prevSearchByDocument);
                    setChangeStyles(!changeStyles);
                  }} />
                </Grid>
              </Grid>
            </Grid>}
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} lg={12} justify='start' alignItems='center'>
          <Grid container spacing={4}>
            <Grid item >
              <SearchByDate action={setFilterByDate} />
            </Grid>
            <Grid item >
              <SearchByStatus action={setFilterByStatus} />
            </Grid>
            {(filterName === 'pending' || filterName === 'finished') &&
            <Grid item style={{ paddingTop: '25px' }}>
              <FormControlLabel control={
                <Switch color='primary'
                  onChange={() => setActualOwner((actualOwner.length === 0) ? user : '')} />} label={t('searchToolbar:own')} labelPlacement='top' />
            </Grid>}
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return null;
  }
};

function areEqual (prevProps, nextProps) {
  const compareTwoArrays = (array1, array2) => array1.every((item, index) => item === array2[index]);
  const equals = (a, b) => (
    a.length === b.length && compareTwoArrays(a, b)
  );
  return equals(prevProps.visibleFor, nextProps.visibleFor);
}

export default memo(SearchToolbar, areEqual);
